import {
  LIVE_CHAT_GROUP,
  LIVE_CHAT_INTEGRATION_NAME,
  LIVE_CHAT_LICENSE,
  LIVE_CHAT_PRODUCT_NAME,
  LIVE_CHAT_SCRIPT_URL,
} from "./liveChatConfig";

const createWidgetQueue = () => {
  const sliceArguments = [].slice;
  const widget = {
    _q: [],
    _h: null,
    _v: "2.0",
    on() {
      return widget._h
        ? widget._h.apply(null, ["on", sliceArguments.call(arguments)])
        : widget._q.push(["on", sliceArguments.call(arguments)]);
    },
    once() {
      return widget._h
        ? widget._h.apply(null, ["once", sliceArguments.call(arguments)])
        : widget._q.push(["once", sliceArguments.call(arguments)]);
    },
    off() {
      return widget._h
        ? widget._h.apply(null, ["off", sliceArguments.call(arguments)])
        : widget._q.push(["off", sliceArguments.call(arguments)]);
    },
    get() {
      if (!widget._h) {
        throw new Error("[LiveChatWidget] You can't use getters before load.");
      }
      return widget._h.apply(null, ["get", sliceArguments.call(arguments)]);
    },
    call() {
      return widget._h
        ? widget._h.apply(null, ["call", sliceArguments.call(arguments)])
        : widget._q.push(["call", sliceArguments.call(arguments)]);
    },
  };
  return widget;
};

const configureLiveChat = (windowObject) => {
  windowObject._lc = windowObject._lc || {};
  windowObject.__lc = windowObject.__lc || {};
  windowObject.__lc.license = LIVE_CHAT_LICENSE;
  windowObject.__lc.integration_name = LIVE_CHAT_INTEGRATION_NAME;
  windowObject.__lc.product_name = LIVE_CHAT_PRODUCT_NAME;
  windowObject.__lc.group = LIVE_CHAT_GROUP;
};

export const initializeLiveChat = ({ windowObject, documentObject }) => {
  if (!windowObject || !documentObject?.head) return undefined;

  configureLiveChat(windowObject);

  const existingScript = documentObject.querySelector(
    `script[src="${LIVE_CHAT_SCRIPT_URL}"]`
  );
  if (existingScript || windowObject.LiveChatWidget) return undefined;

  const widget = createWidgetQueue();
  windowObject.LiveChatWidget = widget;

  let script;
  if (!windowObject.__lc.asyncInit) {
    script = documentObject.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = LIVE_CHAT_SCRIPT_URL;
    script.dataset.liveChatLoader = "true";
    documentObject.head.appendChild(script);
  }

  return () => {
    script?.remove();
    if (windowObject.LiveChatWidget === widget) {
      delete windowObject.LiveChatWidget;
    }
  };
};
